import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormMode, Languages, ServiceStatus, TransitCancelWorkflowSteps } from 'src/app/shared/models/enums.model';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { first } from 'rxjs/operators';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { TransitRequestDto } from 'src/app/front-user/services/e-booking/transit-request/transit-request.model';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { GenericLookup } from 'src/app/shared/models/general.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-marine-estimate-penalty',
  templateUrl: './marine-estimate-penalty.component.html',
  styleUrls: ['./marine-estimate-penalty.component.css']
})
export class MarineEstimatePenaltyComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitCancelWorkflowSteps.EstimatePenalty;
  MarineEstimatePenaltyForm: FormGroup;
  AntipollutionPaymentForm: FormGroup;
  submitted: boolean = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  editFlag: boolean = false;
  cancelFlage: boolean = false;
  LateBookingFlag: boolean = false;
  public Languages: any = Languages;
  newTransitDate: Date;
  oldTransitDate: Date;
  actionDateModified: Date;
  bookingDate: Date;
  //cancelDate: Date;
  lockTaskErrorMessage: boolean = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  displayedLang: any;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  isLoaded: boolean = false;
  @ViewChild('TransitRequest', { static: false }) TransitRequest: TransitRequestComponent;
  isAdmin: boolean;
  numberRegex: any = /^[0-9]+(\.[0-9]+)?$/;
  error: any = { isError: false, errorMessage: '' };
  transitData: TransitRequestDto = new TransitRequestDto();
  responseObj: ResponseObject = new ResponseObject();
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  @Input() public isShow: boolean = true;
  stepHistoryId: any;
  stepData: any;
  @Input() isReadOnly: boolean = false;
  appInstanceId: string = '';
  public transitRequestIdd: string = '';
  public penaltyIdToSearch: string = '';
  PenaltyClausesList: any[] = [
    { Id: 1, NameEN: 'Clause 12 - Item 3', NameAR: 'ماده 12 -البند 3' },
    { Id: 2, NameEN: 'Clause 12 - Item 4', NameAR: 'ماده 12 -البند 4' },
    { Id: 3, NameEN: 'Clause 104 - Item 22', NameAR: 'ماده 104 -البند 22' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private transitService: TransitService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitSrv: TransitService,
    private wfhistoryService: WFHistoryService,
    private router: Router,
    private datePipe: DatePipe  // Add DatePipe

  ) {
    this.displayedLang = this.globalSrv.getLanguage();
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      this.appInstanceId = history.state.data.appInstanceId;
      // this.penaltyIdToSearch = "17";

      // this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
      if (this.appInstanceId && this.appInstanceId.includes('_')) {
        this.transitRequestIdd = this.appInstanceId.split('_')[0];
        this.penaltyIdToSearch = this.appInstanceId.split('_')[1];
      } else {
        this.transitRequestIdd = this.appInstanceId; // Fallback
      }
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm();
    if (this.isReadOnly) {
      this.MarineEstimatePenaltyForm.disable();
      this.formMode = FormMode.Readonly;
    }
  }

  buildForm() {
    this.MarineEstimatePenaltyForm = this.formBuilder.group({
      //CancelDate: new FormControl({ value: '', disabled: true }),
      PenaltyValue: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.pattern(this.numberRegex), Validators.maxLength(150)]],
      PenaltyClauses: ['', Validators.required], // Add this control
      PenaltyReason: [''],
      //CancelTime: [new Date()],
      BookingDate: new FormControl({ value: '', disabled: true }),

      // New fields for Postpone penalty type
      OldTransitDate: new FormControl({ value: '', disabled: true }), // Date only
      NewTransitDate: new FormControl({ value: '', disabled: true }), // Date only
      ActionDateModified: new FormControl({ value: '', disabled: true }), // Date + Time
      ActionTimeModified: new FormControl({ value: '', disabled: true }), // Time picker

    });

  }
  get f() { return this.MarineEstimatePenaltyForm.controls; }


  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        //this.requestStatus = this.baseRequestDTO.StatusId;
        this.isLoaded = true;
        this.transitService.GetByTransitRequestAndPenaltyId(this.transitRequestIdd, parseInt(this.penaltyIdToSearch))
          .subscribe(
            (response: ResponseObject) => {
              if (response.Success && response.Data) {

                const penaltyType = response.Data.PenaltyType; // 1 = Cancel, 2 = Postpone, 3 = LateBooking
                const penaltyDataString = response.Data.PenaltyData;

                if (penaltyDataString) {
                  try {
                    const parsedData = JSON.parse(penaltyDataString);

                    // ==========================================
                    //  Status: Postponement (penaltyType = 2)
                    // ==========================================
                    if (penaltyType == 2 || penaltyType == 4) {
                      this.editFlag = true;
                      this.cancelFlage = false;
                      this.LateBookingFlag = false;

                      // Extract dates from parsed data
                      if (parsedData.Previous) {
                        this.oldTransitDate = new Date(parsedData.Previous);
                      }
                      if (parsedData.Requested) {
                        this.newTransitDate = new Date(parsedData.Requested);
                      }
                      if (response.Data.ModifiedDate) {
                        this.actionDateModified = new Date(response.Data.ModifiedDate);
                      }

                      // Patch form values
                      this.MarineEstimatePenaltyForm.patchValue({
                        OldTransitDate: this.oldTransitDate,
                        NewTransitDate: this.newTransitDate,
                        ActionDateModified: this.actionDateModified,
                        ActionTimeModified: this.actionDateModified
                      });
                    }
                    // ==========================================
                    //  Status: Cancellation (penaltyType = 1)
                    // ==========================================
                    else if (penaltyType == 1) {
                      this.cancelFlage = true;
                      this.editFlag = false;
                      this.LateBookingFlag = false;

                      // Extract old transit date
                      if (parsedData.Requested) {
                        this.oldTransitDate = new Date(parsedData.Requested);
                      }

                      // Extract action date
                      if (response.Data.ModifiedDate) {
                        this.actionDateModified = new Date(response.Data.ModifiedDate);
                      }

                      // Patch form values
                      this.MarineEstimatePenaltyForm.patchValue({
                        OldTransitDate: this.oldTransitDate,
                        ActionDateModified: this.actionDateModified,
                        ActionTimeModified: this.actionDateModified
                      });
                    }
                    // ==========================================
                    //  Status: Late Booking (penaltyType = 3)
                    // ==========================================
                    else if (penaltyType == 3) {
                      this.editFlag = false;
                      this.cancelFlage = false;
                      this.LateBookingFlag = true;

                      // Extract booking date
                      if (parsedData.SubmissionDate) {
                        this.bookingDate = new Date(parsedData.SubmissionDate);
                      }
                      // Extract action date
                      if (response.Data.ModifiedDate) {
                        this.actionDateModified = new Date(response.Data.ModifiedDate);
                      }

                      // Patch form values
                      this.MarineEstimatePenaltyForm.patchValue({
                        BookingDate: this.bookingDate,
                        ActionDateModified: this.actionDateModified,
                        ActionTimeModified: this.actionDateModified
                      });
                    }

                  } catch (e) {
                    console.error('Error parsing PenaltyData JSON:', e);
                  }
                }
              } else {
                console.log("No Penalty found or error occurred");
              }
            },
            error => {
              console.error("Error fetching penalty data", error);
            }
          );

        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getTransitCancelRequestWFHistoryById();
        } else if (this.isReadOnly) {
          this.getTransitCancelRequestWFHistory();
          this.formMode = FormMode.Readonly;
        }
      }
    )
  }

  public getTransitRequest() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          // --- FIX: Patch only after data arrives ---
          if (this.transitData && this.transitData.AgentTransitDate) {
            this.MarineEstimatePenaltyForm.patchValue({
              //CancelDate: new Date(this.transitData.AgentTransitDate),
              //CancelTime: new Date(this.transitData.AgentTransitDate),
            });
            //this.editFlag = true;

          }
          // ------------------------------------------
        }
      });
  }

  getTransitCancelRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepIdByPenaltyID(this.baseRequestId, this.stepId, Number(this.penaltyIdToSearch)).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitCancelRequestWFHistoryCompleted(this.stepData);
        }
      }

    );
  }
  getTransitCancelRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdByIdByPenaltyID(this.baseRequestId, this.stepId, this.stepHistoryId, Number(this.penaltyIdToSearch)).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitCancelRequestWFHistoryCompleted(this.stepData);
      }

    );
  }

  getTransitCancelRequestWFHistoryCompleted(stepData: any) {
    if (!this.stepData) return;
    this.MarineEstimatePenaltyForm.patchValue({
      PenaltyValue: this.stepData.PenaltyValue,
      PenaltyReason: this.stepData.PenaltyReason,
      PenaltyClauses: stepData.PenaltyClauses, // Add this line
      OldTransitDate: this.stepData.OldTransitDate,
      NewTransitDate: this.stepData.NewTransitDate,
      ActionDateModified: this.stepData.ActionDateModified,
      ActionTimeModified: this.stepData.ActionTimeModified,
      BookingDate: this.stepData.BookingDate,
      //CancelDate: this.stepData.CancelDate

      //CancelDate:new Date(this.baseRequestDTO.CancelationDate), 
    });

    // Disable form if coming from request history
    if (this.formMode === FormMode.Readonly || this.isReadOnly) {
      this.MarineEstimatePenaltyForm.disable();
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.MarineEstimatePenaltyForm.invalid) {
      return;
    }

    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

    // Format dates and times before submission
    const formData = this.MarineEstimatePenaltyForm.getRawValue();

    if (formData.ActionDateModified) {
      formData.ActionDateModified = this.datePipe.transform(formData.ActionDateModified, 'YYYY-MM-dd');
    }
    if (formData.ActionTimeModified) {
      formData.ActionTimeModified = this.datePipe.transform(formData.ActionTimeModified, 'HH:mm:ss');
    }
    if (formData.OldTransitDate) {
      formData.OldTransitDate = this.datePipe.transform(formData.OldTransitDate, 'YYYY-MM-dd');
    }
    if (formData.NewTransitDate) {
      formData.NewTransitDate = this.datePipe.transform(formData.NewTransitDate, 'YYYY-MM-dd');
    }
    if (formData.BookingDate) {
      formData.BookingDate = this.datePipe.transform(formData.BookingDate, 'YYYY-MM-dd');
    }

    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(formData);
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;
    this.transitRequestCustomObj.AppInstanceId = this.appInstanceId;

    this.transitService.SubmitEstimatedPenalty(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.MarineEstimatePenaltyForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages && data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser")) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }
        },
        error => {
          this.globalSrv.isLoaderEnabled = false;
          this.loading = false;
          this.showRequest = true;
          this.isErrorMessage = true;
          console.error('Error:', error);
        }
      );
  }

}
